import isHotKey from 'is-hotkey'

export default function CommentSubmitPlugin({
  submit = x => x,
  cancel = x => x,
} = {}) {
  return [
    {
      onKeyDown(event, editor, next) {
        if (isHotKey('mod+enter', event)) {
          return submit(editor)
        } else if (isHotKey('Escape', event)) {
          return cancel(editor)
        }
        return next()
      },
    },
  ]
}
